import React, { Component } from "react"

class WhyUseUs extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isCompanies: false
    }
    this.renderAbas = this.renderAbas.bind(this)
    this.renderContent = this.renderContent.bind(this)
    this.toggleIsCompanies = this.toggleIsCompanies.bind(this)
  }

  toggleIsCompanies = () => {
    this.setState({ isCompanies: !this.state.isCompanies })
  }

  renderAbas = () => {
    if (!this.state.isCompanies) {
      return (
        <ul className="abas">
          <li className="active">
            <a className="#aba-1">Companies</a>
          </li>
          <li>
            <a className="#aba-2" onClick={this.toggleIsCompanies}>
              Employees
            </a>
          </li>
        </ul>
      )
    }
    return (
      <ul className="abas">
        <li>
          <a className="#aba-1" onClick={this.toggleIsCompanies}>
            Companies
          </a>
        </li>
        <li className="active">
          <a className="#aba-2">Employees</a>
        </li>
      </ul>
    )
  }

  renderContent = () => {
    if (!this.state.isCompanies) {
      return (
        <div  id="aba-1" className="aba">
          <ul className="lista-benefits companies">
            <h4>When the employee pays all of the cost:</h4>
            <li className="first">
              Use Lunch.Team for free as a core part of your health and well
              being programme offering healthy eating for employees from some of
              the cities finest restaurants at the touch of a button.
            </li>
            <h4>When the company pays part or all of the cost:</h4>
            <li>
              Attract top talent, increase productivity and make the team feel
              loved with Lunch.Team Premium, our canteen replacement solution.
            </li>
            <li>
              Use our variable subsidy programme to offer lunches for individual
              teams or the whole company in a way that works practically and
              financially.
            </li>
            <li>
              Our simple, quick ordering software with native apps and
              integrated accounts package means the Lunch.Team solution is
              completely management free for your company.
            </li>
            <li>
              Whether ordering platters for meetings, doughnuts for the team or
              lunches for the whole company get one simple bi-weekly bill with
              full traceability.
            </li>
          </ul>
        </div>
      )
    }
    return (
      <div  id="aba-2" className="aba">
        <ul className="lista-benefits">
          <li>
            Have a meeting, taking some exercise or simply don't like the
            weather out there? Get your lunch delivered for the same price as if
            you walked to the store.
          </li>
          <li>
            Tired of the local options, trying to eat healthily or have specific
            dietary requirements? Let Lunch.Team broaden your lunch horizons
            with our daily rotation of some of the best restaurants in town.
          </li>
          <li>
            Time pressed or out of the office? Use our super simple suite of
            software with native apps, customisable notifications, and one touch
            reordering to make sure you're properly fueled to get the job done.
          </li>
        </ul>
      </div>
    )
  }

  render() {
    return (
      <div className="secao-4">
        <div ref={this.props.whyUseUsRef} className="wrap">
          <div className="w-72 left">
            <h3>Why Use Us</h3>
            <div className="tabs">
              {this.renderAbas()}
              <div className="abas-content">{this.renderContent()}</div>
            </div>
            <a onClick={this.props.HandleFindOutMore} className="bt get-more-info">Find out more</a>
          </div>
        </div>
      </div>
    )
  }
}

export default WhyUseUs



// WEBPACK FOOTER //
// ./src/containers/Landing/WhyUseUs/index.js